module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.slotComponent) ? _c(_vm.slotComponent, _vm._b({
    tag: "component",
    staticClass: "slot-footer"
  }, 'component', _vm.slotProps, false)) : _c('div', {
    staticClass: "default-footer"
  }, [_c('button', {
    staticClass: "default-footer_btn-ok",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("ОК")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-281de9f4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppModal/components/Footer.vue
// module id = 1e80942304aa8e552a88
// module chunks = 89